import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

/**
 * Shared auth page chrome — left brand panel (desktop) + right form container.
 * Used by /auth and /verify.
 */
export function AuthShell({ children }) {
  return (
    <div className="relative min-h-screen bg-background grain text-foreground">
      {/* Background layers */}
      <div className="absolute inset-0 -z-10 grid-overlay opacity-40" />
      <div className="absolute inset-0 -z-10 radial-glow" />
      <div className="absolute left-1/2 top-0 -z-10 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" />

      <div className="relative flex min-h-screen">
        <aside className="hidden flex-col justify-between border-r border-border/60 bg-card/20 backdrop-blur-sm p-10 lg:flex lg:w-[42%]">
          <Link to="/" className="inline-block w-fit"><Logo /></Link>
          <div className="space-y-6">
            <div className="label-mono text-primary">[ 00 ] · Premium intelligence terminal</div>
            <h2
              className="text-balance text-4xl font-light leading-[0.95] tracking-[-0.03em] sm:text-5xl"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              The frontier<br />
              <span className="copper-text font-medium">made exclusive.</span>
            </h2>
            <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
              ChatGPT Astra, Claude Opus 5 & Gemini Pro + live web RAG + racing. No card. No queue.
              Acquire a code, redeem, enter.
            </p>
            <div className="space-y-2 pt-3 label-mono text-muted-foreground">
              <div className="flex items-center gap-2"><span className="h-px w-3 bg-primary" /> GPT vs Claude vs Gemini racing</div>
              <div className="flex items-center gap-2"><span className="h-px w-3 bg-primary" /> Tavily live web search</div>
              <div className="flex items-center gap-2"><span className="h-px w-3 bg-primary" /> Multimodal · images · PDFs</div>
            </div>
          </div>
          <div className="font-mono text-[10px] tracking-widest text-muted-foreground">
            © 2030 · sabzy.ai · all systems nominal
          </div>
        </aside>

        <main className="flex flex-1 items-center justify-center p-5 sm:p-8 lg:p-12">
          <div className="w-full max-w-md border border-border/60 bg-card/60 backdrop-blur-xl p-8 sm:p-10 shadow-[0_20px_80px_-20px_rgba(0,0,0,0.5)]">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
